<template>
  <div v-if="documentUuid">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <DataTable
            type="view"
            :headers="selectedHeaders"
            :documentUuid="documentUuid"
            ref="datatable"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
export default {
  data() {
    return {
      documentUuid: null,
      selectedHeaders: [],
      headers: [
        {
          text: 'Date',
          align: 'start',
          sortable: true,
          value: 'created_at',
        },
        {
          text: 'Fichier',
          align: 'start',
          sortable: true,
          value: 'titre',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  watch: {
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
  },
  components: {
    DataTable,
  },
  methods: {
    init() {
      this.documentUuid = this.$route.params.documentUuid;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
